module.exports = __webpack_public_path__ + "static/media/card_2x.db098e89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/san-diego/card_2x.jpg
// module id = 950
// module chunks = 27